import Endpoints from "../constants/Endpoints";
import {RestRequestGET, RestRequestPOST} from "../libs/RestRequest";
import isResponseValid from "../libs/isResponseValid";
import reduxStore from "../redux/store";
import {setSaveStatusError} from "../redux/actions";
import Tr from "../translations/Translations";

const showError = (message) => {
	reduxStore.dispatch(setSaveStatusError(message))
}

const getFilesAdnFolders = async (demandId) => {
	try {
		const resp = await RestRequestGET(Endpoints.EZDRP(demandId));
		if(isResponseValid(resp, showError)) {
			return resp.result;
		}
	} catch (e) {
		console.error(e);
		showError(Tr('internal_server_error'));
	}
	throw new Error();
}

const downloadFileFromEzdrp = async (demandId, file) => {
	try {
		return await RestRequestPOST(Endpoints.EZDRP(demandId), file);
	} catch (e) {
		console.error(e);
	}
	return {uploadStatus: "ERROR"}
}

const shareArchiveEzdrp = async (demandId) => {
	try {
		return await RestRequestPOST(Endpoints.EZDRP_SHARE_ARCHIVE(demandId));
	} catch (e) {
		console.error(e);
	}
	return {uploadStatus: "ERROR"}
}

export default {
	getFilesAdnFolders,
	downloadFileFromEzdrp,
	shareArchiveEzdrp
};

